export enum ReadinessStatus {
  Pass = 0,
  Fail = 1,
  /** Optional group started but not finished, or a soft warning. */
  Warn = 2,
  /** Optional group nobody has opted into. Not counted in the score. */
  Skip = 3,
}

export interface IReadinessCheck {
  key: string;
  label: string;
  status: ReadinessStatus;
  /** Why it failed. Never contains the setting's value. */
  detail: string | null;
  /** Dashboard route that fixes it. */
  fixPath: string | null;
}

export interface IReadinessSection {
  key: string;
  label: string;
  description: string;
  checks: IReadinessCheck[];
  passed: number;
  total: number;
}

export interface ICustomerReadiness {
  customerId: string;
  name: string;
  generatedAt: string;
  passed: number;
  total: number;
  /** Things the endpoint cannot see - Azure, DNS, pipelines. */
  notChecked: string[];
  sections: IReadinessSection[];
}
